import { AxiosRequestConfig } from 'axios';
import { HttpResponse, ajax } from '../../../../common/ajax';
import { config } from '../../config';
import {
  OrderDetailsModel,
  OrderItemModel,
  OrderProductItemModel,
  OrdersStatisticsModel,
  TransactionItemModel,
} from '../../models/Orders';

interface IOrderService {
  getOrders: (
    queryString?: string,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<OrderItemModel[]>>;
  getOrderProducts: (
    orderId: number,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<OrderProductItemModel[]>>;
  getOrdersStatistics: (
    newerhanDate?: Date,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<OrdersStatisticsModel>>;
  getOrderDetails: (
    orderId: number,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<OrderDetailsModel>>;
  downloadOrdersReport: (
    filename: string,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<null>>;
  downloadOrderInvoice: (
    orderId: number,
    filename: string,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<null>>;
  getTransactions: (
    queryString?: string,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<TransactionItemModel[]>>;
  downloadTransactionsReport: (
    filename: string,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<null>>;
}

export const orderService: IOrderService = {
  getOrders(queryString, axiosConfig) {
    return ajax.get<OrderItemModel[]>(
      `${config.benefitApiUrl}/odata/orders?${queryString}`,
      axiosConfig,
    );
  },
  getOrderProducts(orderId, axiosConfig) {
    return ajax.get<OrderProductItemModel[]>(
      `${config.benefitApiUrl}/odata/orders/${orderId}/products`,
      axiosConfig,
    );
  },
  getOrdersStatistics(newerThanDate, axiosConfig) {
    const date = newerThanDate ? newerThanDate.toISOString() : null;

    return ajax.get<OrdersStatisticsModel>(
      `${config.benefitApiUrl}/orders/statistics?newerThanDate=${date}`,
      axiosConfig,
    );
  },
  getOrderDetails(orderId, axiosConfig) {
    return ajax.get<OrderDetailsModel>(
      `${config.benefitApiUrl}/orders/${orderId}`,
      axiosConfig,
    );
  },
  downloadOrdersReport(filename, axiosConfig) {
    return ajax.downloadFile(
      `${config.benefitApiUrl}/orders/report`,
      filename,
      'xlsx',
      axiosConfig,
    );
  },
  downloadOrderInvoice(orderId, filename, axiosConfig) {
    return ajax.downloadFile(
      `${config.benefitApiUrl}/orders/${orderId}/invoice`,
      filename,
      'pdf',
      axiosConfig,
    );
  },
  getTransactions(queryString, axiosConfig) {
    return ajax.get<TransactionItemModel[]>(
      `${config.benefitApiUrl}/odata/transactions?${queryString}`,
      axiosConfig,
    );
  },
  downloadTransactionsReport(filename, axiosConfig) {
    return ajax.downloadFile(
      `${config.benefitApiUrl}/transactions/report`,
      filename,
      'xlsx',
      axiosConfig,
    );
  },
};
